export default "__VITE_ASSET__Cn5ahtK8__"